export default __webpack_public_path__ + "static/media/36I-120772_-43969_0.43635ca2.jpg";